<div class="completed-container">
  <img [draggable]="false" class="completed-image" src="{{gameIcon}}">

  <div>
    <div class="completed-message">
      <ng-content></ng-content>
    </div>
    <img [draggable]="false" class="completed-image-line" src="/img/popup/won-game-types/lijn.svg">
  </div>
  <div class="buttons">
    <app-button-back2 (click)="onReplay(); audio.playSoundClick();" *ngIf="enableReplay">{{audio.text.global.playagain}}</app-button-back2>
    <app-button-next3 (click)="onClose(); audio.playSoundClick();">{{audio.text.global.continue}}</app-button-next3>



  </div>


</div>
